import styles from './InputButton.pcss'

interface Props {
	disabled?: boolean
	onClick: () => void
	children: React.ReactNode
}

export function InputButton({ disabled, onClick, children }: Props) {
	return (
		<button
			type="button"
			className={styles.container}
			disabled={disabled}
			onClick={onClick}
		>
			{children}
		</button>
	)
}
